/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_TitleInputs */

const en_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Position`)
};

const fr_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position de l'Evenement`)
};

const de_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsposition`)
};

const it_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione dell'evento`)
};

const ru_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция события`)
};

const es_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición del evento`)
};

const zh_cn2_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件位置`)
};

const ja_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントポジション`)
};

const hi_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना की स्थिति`)
};

const pt_pt2_position_title = /** @type {(inputs: Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição do evento`)
};

/**
* | output |
* | --- |
* | "Event Position" |
*
* @param {Position_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_title = /** @type {((inputs?: Position_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_title(inputs)
	if (locale === "de") return de_position_title(inputs)
	if (locale === "it") return it_position_title(inputs)
	if (locale === "ru") return ru_position_title(inputs)
	if (locale === "es") return es_position_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_title(inputs)
	if (locale === "ja") return ja_position_title(inputs)
	if (locale === "hi") return hi_position_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_title(inputs)
	return en_position_title(inputs)
});